import { render, staticRenderFns } from "./KoPrivacyPolicy.vue?vue&type=template&id=692f5bb8&scoped=true"
import script from "./KoPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./KoPrivacyPolicy.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "692f5bb8",
  null
  ,true
)

export default component.exports